export const services = [
  {
    slug: "consulting",
    stage: "01",
    title: "Consulting",
    headline: "Free 30-minute consultation",
    short:
      "Sit down with Ananda — in person, on a call, or over WhatsApp. We map your space, your taste, and your budget before a single piece is designed.",
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&q=80",
    serviceType: "Interior Design Consulting",
    deliverables: [
      "Site visit or photo/video walk-through of your space",
      "Style and reference review — what you love, what you don't",
      "Budget bands and realistic timeline expectations",
      "Honest opinion on what to build vs. what to source vs. what to skip",
    ],
    when: "Day 1 — before any commitment, no fee, no obligation.",
    cta: "Book a Free Consultation",
    description:
      "The consulting stage is where 90% of project failures get caught early. Ananda spends 30 minutes understanding your home, your habits, and your money — then tells you, plainly, what's worth doing.",
  },
  {
    slug: "design",
    stage: "02",
    title: "Design",
    headline: "Bespoke designs, sized to your space",
    short:
      "Once we agree on direction, Ananda produces piece-level designs: dimensions, materials, finishes, hardware, and indicative pricing. You approve before anything is built.",
    image: "https://images.unsplash.com/photo-1503602642458-232111445657?w=1200&q=80",
    serviceType: "Bespoke Furniture Design",
    deliverables: [
      "Detailed sketches or renders for each piece",
      "Material and finish samples (where relevant)",
      "Exact dimensions tuned to your room",
      "Itemised, factory-direct pricing — no hidden margins",
      "Iterations until you're happy",
    ],
    when: "Week 1–2 after consultation. Design fee rolls into the final build cost.",
    cta: "Start the Design Phase",
    description:
      "Design is where Ananda's 40 years of factory experience pays off — every spec he writes is something he knows can be built well, on time, in Nepal. No imported impossibilities, no Pinterest fantasies that fall apart in a year.",
  },
  {
    slug: "build",
    stage: "03",
    title: "Build & Deliver",
    headline: "Factory-direct fabrication, end-to-end accountability",
    short:
      "Approved designs go straight to Ananda's network of factories. He oversees fabrication, quality-checks every piece, and handles delivery and installation in your home.",
    image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1200&q=80",
    serviceType: "Custom Furniture Fabrication & Installation",
    deliverables: [
      "Fabrication at trusted factories — Ananda personally inspects",
      "Mid-build photo updates so there are no surprises",
      "White-glove delivery and on-site installation",
      "Post-install snag-fix and aftercare",
    ],
    when: "3–14 weeks depending on scope. Confirmed before fabrication starts.",
    cta: "Talk About Your Build",
    description:
      "This is the stage that separates Ananda from showrooms. Because he owns the relationship with the factory, problems get fixed at the factory — not blamed on a third party.",
  },
];

export const servicesFaqs = [
  {
    q: "Do I have to do all three stages?",
    a: "No. Many clients consult once and source pieces themselves. Others do consulting plus design, then take the spec elsewhere. Most who reach the design stage stay all the way through to build — because the cost advantage of factory-direct is real.",
  },
  {
    q: "Is the consultation really free?",
    a: "Yes. The first 30 minutes are free, in person or over WhatsApp/call. There is no obligation to continue.",
  },
  {
    q: "How is design priced?",
    a: "Design fees are project-scoped and quoted before work starts. For clients who continue to build, the design fee rolls into the final fabrication cost.",
  },
  {
    q: "Where do you build?",
    a: "Ananda partners with vetted factories across Kathmandu Valley. He has a 40-year relationship with these workshops and personally inspects every piece before delivery.",
  },
];
